<!--
 * @Author: 仙道
 * @Date: 2022-06-21 16:12:52
 * @LastEditTime: 2022-09-26 22:48:35
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/workbench/components/PanelThree.vue
-->

<template>
  <!-- <a-table :columns="columns" :dataSource="dataSource" :loading="loading" :pagination="ipagination" :scroll="{x:true}" bordered class="j-table-force-wrap" ref="table" rowKey="id" size="middle" style="width: 100%; height: 395px; background-color: #fff">
        <template slot="htmlSlot" slot-scope="text">
            <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
            <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
            <img :src="getImgView(text)" alt height="25px" style="max-width:80px;font-size: 12px;font-style: italic;" v-else />
        </template>
        <template slot="fileSlot" slot-scope="text">
            <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
            <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>
        <span slot="levelSlot" slot-scope="alertLevel, item">
            <span v-if="item.alertLevel==1">
                <a-tag color="#ff4d4f">紧急告警</a-tag>
            </span>
            <span v-else-if="item.alertLevel==2">
                <a-tag color="#faad14">严重告警</a-tag>
            </span>
            <span v-else>
                <a-tag color="#52c41a">一般告警</a-tag>
            </span>
        </span>
        <span slot="recoverySlot" slot-scope="isRecovery, item">
            <a-tag color="#ff4d4f" v-if="item.isRecovery==0">未恢复</a-tag>
            <a-tag color="#52c41a" v-else>已恢复</a-tag>
        </span>
  </a-table>-->
  <grid-table :columns="columns" :queryParams="queryParams" :url="url" ref="table">
    <template slot="htmlSlot" slot-scope="text">
      <div v-html="text"></div>
    </template>
    <template slot="imgSlot" slot-scope="text">
      <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
      <img :src="getImgView(text)" alt height="25px" style="max-width:80px;font-size: 12px;font-style: italic;" v-else />
    </template>
    <template slot="fileSlot" slot-scope="text">
      <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
      <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
    </template>
    <span slot="levelSlot" slot-scope="alertLevel, item">
      <span v-if="item.alertLevel==1">
        <a-tag color="#ff4d4f">紧急告警</a-tag>
      </span>
      <span v-else-if="item.alertLevel==2">
        <a-tag color="#faad14">严重告警</a-tag>
      </span>
      <span v-else>
        <a-tag color="#52c41a">一般告警</a-tag>
      </span>
    </span>
    <span slot="recoverySlot" slot-scope="text, item">
      <a-tag color="#ff4d4f" v-if="item.isRecovery">未恢复</a-tag>
      <a-tag color="#52c41a" v-else>已恢复</a-tag>
    </span>
  </grid-table>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GridTable from "../components/Itable.vue";

  export default {
    name: 'PendingThree',
    components: {
      GridTable
    },

    // 定义属性
    data () {
      const forceNowrap = (text) => (<span class="j-force-nowrap">{text}</span>)
      return {
        disableMixinCreated: true,
        queryParams: {},
        url: '/alert/iotAlert/list',
        columns: [
          {
            title: '告警描述',
            align: 'center',
            dataIndex: 'summary',
            width: '50%',
            align: 'left'
          },
          {
            title: '告警时间',
            align: 'center',
            dataIndex: 'alertTime',
            customRender: forceNowrap
          },
          {
            title: '告警级别',
            align: 'center',
            dataIndex: 'alertLevel_dictText',
            scopedSlots: { customRender: 'levelSlot' }
          },
          {
            title: '告警来源',
            align: 'center',
            dataIndex: 'alertType_dictText',
            customRender: forceNowrap
          },
          {
            title: '状态',
            align: 'center',
            dataIndex: 'isRecovery',
            scopedSlots: { customRender: 'recoverySlot' }
          },
        ],
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      queryData () {
        this.$refs.table.loadData()
      }
    }
  }
</script>

<style lang='scss' scoped>


</style>